import React from 'react'

import Text from 'components/common/Text'
import { Modal } from 'components/Modal'

import { Wrapper, Buttons, Button } from './styles'

const styles = {
    modal: {
        overflow: 'hidden',
        padding: 0,
        width: '340px',
        height: '170px',
        maxWidth: 'unset',
        maxHeight: 'unset',
        border: '1px solid rgba(0, 0, 0, 0.12)',
        boxSizing: 'border-box',
        boxShadow:
            '0px 8px 24px rgba(17, 17, 26, 0.06), 0px 12px 32px rgba(17, 17, 26, 0.06)',
        borderRadius: '8px',
        padding: '25px',
    },
}

const copy = 'Are you sure you want to quit the current Quiz?'

const EndQuizPopUp = ({ isOpen, close, cancelQuiz }) => {
    return (
        <Modal
            styles={styles}
            isModalOpen={isOpen}
            showCloseIcon={false}
            onCloseModal={close}
        >
            <Wrapper>
                <Text color="#000008" level="3">
                    {copy}
                </Text>
                <Buttons>
                    <Button
                        $secondary
                        onClick={() => {
                            cancelQuiz()
                            close()
                        }}
                    >
                        Yes
                    </Button>
                    <Button onClick={close}>No</Button>
                </Buttons>
            </Wrapper>
        </Modal>
    )
}

export default EndQuizPopUp
